module.exports = __webpack_public_path__ + "static/img/nav_fix4.7f7f6e4b.png";